import React, { useCallback } from 'react';
import { FileInputWUT } from '../../inputs/file-input/file-input-wut';
import { useFieldAttributes } from '../../sdk/components';
import { FieldDescriptionWUT, FieldErrorWUT, FieldLabelWUT } from '../../sdk/components-wut';
import { FileUploadDetails, useFileUpload } from '../autocomplete/wut/FileUpload';
import { useFileUploadController } from './use-file-upload-controller';
export const FileUploadWUT = ({ id, target, label, description, value, onChange, onFocus, onBlur, error, disabled = false, buttonText, uploadFileFormats, valueSliderLimit, required, hideLabel, hideAsterisk, explanationText, FieldLayout, requiredIndicatorType, requiredIndicatorPlacement, hasError = false, errorMessage })=>{
    const { labelId, inputId, errorId, descriptionId, ariaDescribedBy } = useFieldAttributes(id, error, description);
    const fileUploadButtonRef = React.useRef(null);
    const handleFilesCleared = useCallback(()=>{
        fileUploadButtonRef.current?.focus();
    }, []);
    const { files, limitError, hover, getExplanationText, handleChange, handleDelete, accept, handleBlur } = useFileUploadController({
        valueSliderLimit,
        value,
        explanationText,
        target,
        onChange,
        uploadFileFormats,
        onBlur,
        onFilesCleared: handleFilesCleared
    });
    const { fileInputRef, textBelowButtonRef, fileErrorMessage } = useFileUpload({
        files
    });
    const _errorMessage = fileErrorMessage || limitError || errorMessage;
    return /*#__PURE__*/ React.createElement(FieldLayout, {
        fieldId: id,
        renderLabel: ()=>/*#__PURE__*/ React.createElement(FieldLabelWUT, {
                labelId: labelId,
                htmlFor: inputId,
                required: required,
                label: label,
                hideLabel: hideLabel,
                requiredIndicatorHidden: hideAsterisk,
                requiredIndicatorType: requiredIndicatorType,
                requiredIndicatorPlacement: requiredIndicatorPlacement
            }),
        renderInput: ()=>/*#__PURE__*/ React.createElement(FileInputWUT, {
                onFocus: onFocus,
                onBlur: handleBlur,
                disabled: disabled,
                buttonText: buttonText,
                valueSliderLimit: valueSliderLimit,
                required: required,
                inputId: inputId,
                ariaLabelledBy: labelId,
                ariaDescribedBy: ariaDescribedBy,
                files: files,
                hover: hover,
                handleChange: handleChange,
                accept: accept,
                fileInputRef: fileInputRef,
                fileUploadButtonRef: fileUploadButtonRef,
                textBelowButtonRef: textBelowButtonRef,
                hasError: hasError,
                fieldId: id
            }),
        renderDescription: ()=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(FileUploadDetails, {
                fileInputRef: fileInputRef,
                textBelowButtonRef: textBelowButtonRef,
                files: files,
                onDeleteClick: handleDelete,
                hasError: Boolean(_errorMessage),
                explanationText: getExplanationText()
            }), /*#__PURE__*/ React.createElement(FieldErrorWUT, {
                target: target,
                hasError: Boolean(_errorMessage),
                errorMessage: _errorMessage,
                id: errorId
            }), /*#__PURE__*/ React.createElement(FieldDescriptionWUT, {
                description: description,
                id: descriptionId
            }))
    });
};

//# sourceMappingURL=file-upload-wut.js.map